import { parseServerDate } from 'utils/helpers';

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const pad = (n: number) => String(n).padStart(2, '0');

export function formatFullDateTime(iso: string): string {
  const d = parseServerDate(iso);
  return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(
    d.getHours(),
  )}:${pad(d.getMinutes())}`;
}

export function formatAbsoluteDate(iso: string): { date: string; time: string } {
  const d = parseServerDate(iso);
  return {
    date: `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`,
    time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
  };
}

export function relativeLastSeenLabel(iso: string, now: number = Date.now()): string | null {
  const diffMs = now - parseServerDate(iso).getTime();
  if (diffMs <= -MINUTE || diffMs >= DAY) return null;
  const elapsed = Math.max(0, diffMs);
  if (elapsed < MINUTE) return 'just now';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)} min ago`;
  return `${Math.floor(elapsed / HOUR)} h ago`;
}
